/**
 * Mietwagen-Status — Anzeige-Helfer (Issue #425)
 *
 * Beschriftungen + Tailwind-Klassen für das Status-Badge auf Mietwagen-Akten.
 * Die fachliche State Machine (`canTransition`) liegt in
 * `@shared/utils/mietwagenStatus`; hier nur die UI-Repräsentation.
 */

import type { MietwagenStatus } from "@shared/utils/mietwagenStatus";

export type { MietwagenStatus } from "@shared/utils/mietwagenStatus";
export { MIETWAGEN_STATUS_VALUES, canTransition } from "@shared/utils/mietwagenStatus";

export const MIETWAGEN_STATUS_LABELS: Record<MietwagenStatus, string> = {
  vertrag_offen: "Vertrag offen",
  uebergeben: "Übergeben",
  in_miete: "In Miete",
  zurueckgegeben: "Zurückgegeben",
  abgerechnet: "Abgerechnet",
  abgeschlossen: "Abgeschlossen",
};

/**
 * Farbschema: dezent, mit erkennbarer Progression über den Lebenszyklus.
 * Folgt dem reduzierten Stil der App (siehe STATUS_COLORS in supabase.ts) —
 * Pastell-Hintergrund + dunkler Text, kein gesättigter Tag-Look.
 */
export const MIETWAGEN_STATUS_COLORS: Record<MietwagenStatus, string> = {
  vertrag_offen: "bg-amber-50 text-amber-700",
  uebergeben: "bg-blue-50 text-blue-700",
  in_miete: "bg-indigo-50 text-indigo-700",
  zurueckgegeben: "bg-emerald-50 text-emerald-700",
  abgerechnet: "bg-gray-100 text-gray-600",
  abgeschlossen: "bg-green-50 text-green-700",
};

export function isMietwagenStatus(value: unknown): value is MietwagenStatus {
  return (
    typeof value === "string" &&
    value in MIETWAGEN_STATUS_LABELS
  );
}
